import { render, staticRenderFns } from "./HelpDefault.vue?vue&type=template&id=50af09a6&scoped=true&"
import script from "./HelpDefault.vue?vue&type=script&lang=js&"
export * from "./HelpDefault.vue?vue&type=script&lang=js&"
import style0 from "./HelpDefault.vue?vue&type=style&index=0&id=50af09a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50af09a6",
  null
  
)

export default component.exports